import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import SolutionsViewClaimTab from './SolutionsViewClaimTab';
import SolutionsManagementTab from './SolutionsManagementTab';
import TransactionsTab from './TransactionsTab';

const SolutionsMainTab = (props) => {
  const [subTab, setSubTab] = useState(0);

  return (
    <Box>
      <Tabs
        value={subTab}
        onChange={(e, v) => setSubTab(v)}
        sx={{
          mb: 2,
          minHeight: 0,
          '& .MuiTab-root': {
            color: '#00EDC3',
            fontWeight: 400,
            minHeight: 0,
            px: 3,
            py: 1.5,
            fontSize: 16,
            fontFamily: 'Questrial, normal',
            background: 'transparent',
            borderRadius: 2,
            transition: 'background 0.2s',
            textTransform: 'none',
            letterSpacing: '0.5px',
          },
          '& .Mui-selected': {
            color: '#00EDC3',
            background: 'rgba(0,237,195,0.08)',
            fontWeight: 600,
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#00EDC3',
            height: 2,
          },
        }}
      >
        <Tab label="View & Claim" />
        <Tab label="Management" />
        <Tab label="Transactions" />
      </Tabs>
      {subTab === 0 && <SolutionsViewClaimTab {...props} />}
      {subTab === 1 && <SolutionsManagementTab {...props} />}
      {subTab === 2 && <TransactionsTab {...props} daoCodebases={props.daoCodebases} />}
    </Box>
  );
};

export default SolutionsMainTab;
